import { AfterViewInit, Component, ComponentRef, ElementRef, EventEmitter, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DownloadableFileSet } from 'src/app/core/interfaces/general/downloadable-file';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FileService } from 'src/app/core/services/utelize/general/file-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PageCompDownloadBoxComponent } from 'src/app/core/page-components/page-comp-download-box/page-comp-download-box.component';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDownloadFileService } from 'src/app/core/services/utelize/system/type/types-download-file-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-download-centre-modal-form',
  templateUrl: './download-centre-modal-form.component.html',
  styleUrls: ['./download-centre-modal-form.component.scss']
})

export class DownloadCentreModalFormComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Output() thisFormCancelled   : EventEmitter<void>=new EventEmitter<void>();
  @Output() thisFormHasBeenSaved: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('downloadCentreForm', { static: false }) downloadCentreForm!: TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;

  @ViewChildren('categoryContainer') categoryContainers!: QueryList<ElementRef>;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  get collapseContainers () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DownloadCentreCollapseContainers,  false); }
  get collapseSureSimLogo() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DownloadCentreCollapseSureSimLogo, false); }
  
  private downloadBoxRefs        : ComponentRef<PageCompDownloadBoxComponent>[]=[];
  private downloadFileTypeIdData!: IdAndDescriptionDTO[];
  private initialStatus          : string="Download any of the available files below";
  private thisFormModalRef!      : NgbModalRef;
                                                                     
  public alertColourProgress : string=AlertClassColour.Green;
  public appTitle            : string =this.platformInviewService.getApplicationTitle();
  public categoryVisibility  : Record<string, boolean>={};
  public curUser             : SystemUserDTO;
  public downloadCategories  : string[]=[];
  public formSubmitted       : boolean =false;
  public formTitle           : string  ="Download Centre";
  public groupedDownloadFiles: Record<string, DownloadableFileSet[]>={};
  public isPlatformModeInview: boolean=environment.platformModeInview;
  public ourCompanyName      : string =this.platformInviewService.getOurCompanyName();
  public progressInformation : string =this.initialStatus;
  public showSureSimLogo     : boolean=true;
  public submitButtonEnabled : boolean=false;
  public thisForm!           : UntypedFormGroup;
  public usageLimitsChanged  : boolean=false;
  public year                : number =new Date().getFullYear();

  constructor(
    private authenticationService   : AuthenticationService,
    private configSystemService     : ConfigSystemService,
    private exceptionsService       : ExceptionsService,
    private fileService             : FileService,
    private formBuilder             : UntypedFormBuilder,
    private lastPassKillerService   : LastPassKillerService,
    private modalService            : NgbModal,
    private platformInviewService   : PlatformInviewService,
    private typesDownloadFileService: TypesDownloadFileService,
    private viewContainerRef        : ViewContainerRef
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.downloadFileTypes();

      this.alertColourProgress=AlertClassColour.Green;
      this.downloadBoxRefs    =[];
      this.formSubmitted      =false;
      this.progressInformation=this.initialStatus;
      this.showSureSimLogo    =!this.collapseSureSimLogo;
      this.submitButtonEnabled=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.thisFormModalRef=this.modalService.open(this.downloadCentreForm, { backdrop   : this.modalBackGround,
                                                                              keyboard   : false,
                                                                              scrollable : true,
                                                                              size       : msSize.FullScreen,
                                                                              windowClass: "modal-fullscreen" });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm
  
  get formOfThis() {
    return this.thisForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);
       this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        // this.addFormControl(this.thisForm, "iccid", "", []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        // this.thisForm.controls["iccid"].setValue();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public thisFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.thisForm.valid) {

      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
    
  private downloadFileTypes() {
    try {
      this.typesDownloadFileService.getIdAndDescription()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.downloadFileTypeIdData=(data as IdAndDescriptionDTO[]);   
          this.downloadData();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public downloadData() {
    try {
      this.fileService.downloadDownloadableFiles(this.curUser.userId)
        .pipe(
          catchError(error => throwError(() => new Error(this.exceptionsService.formatHttpError(error))))
        )
        .subscribe({
          next: data => {
            this.formSubmitted  =false;
            this.downloadBoxRefs=[];
  
            const grouped: Record<string, DownloadableFileSet[]>={};
            
            data.forEach(file => {
              const categoryObj: IdAndDescriptionDTO | undefined=this.downloadFileTypeIdData.find(x => x.id==file.downloadFileTypeID);

              const category=categoryObj ? categoryObj["description"] : "Uncategorised";

              if (!grouped[category])
                grouped[category]=[];

              grouped[category].push(file);
            });
  
            this.downloadCategories  =Object.keys(grouped);
            this.groupedDownloadFiles=grouped;

            this.categoryVisibility={};

            for (const category of this.downloadCategories) {
              this.categoryVisibility[category]=!this.collapseContainers;
            }
  
            setTimeout(() => {
              const categoryMap=new Map<string, ElementRef>();
            
              this.categoryContainers.forEach(container => {
                const category=container.nativeElement.getAttribute("data-category");
                
                if (category)
                  categoryMap.set(category, container);
              });
            
              for (const category of this.downloadCategories) {
                const container=categoryMap.get(category);

                if (!container)
                  continue;

                this.renderDownloadBoxes(category, grouped[category], container.nativeElement);
              }
            });
          },
          error: error => {
            this.alertColourProgress=AlertClassColour.Red;
            this.progressInformation=error.message;
            this.exceptionsService.handleException(new Error(error));
          }
        });
    } catch (e) {
      this.exceptionsService.handleException(e as Error);
    }
  }
    
  public onArrowClicked() {
    try {
      this.showSureSimLogo=!this.showSureSimLogo;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleCategoryVisibility(category: string): void {
    try {
      this.categoryVisibility[category]=!this.categoryVisibility[category];

      if (this.categoryVisibility[category]) {
        setTimeout(() => {
          const container=this.categoryContainers.find(container =>
            container.nativeElement.getAttribute("data-category")===category
          )?.nativeElement;
  
          if (!container)
            return;
  
          const files=this.groupedDownloadFiles[category];
          if (!files)
            return;
  
          this.renderDownloadBoxes(category, files, container);
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private renderDownloadBoxes(category: string, files: DownloadableFileSet[], container: HTMLElement): void {
    try {
      files.forEach(file => {
        const colDiv                        =document.createElement("div");
        colDiv.className                    ="col-12 col-sm-6 col-md-4 col-lg-3 mb-4";
        const compRef                       =this.viewContainerRef.createComponent(PageCompDownloadBoxComponent);
        compRef.instance.downloadableFileSet=file;
    
        compRef.instance.fileDownloadedEvent.subscribe(filename => {
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=`'${filename}' has been downloaded`;
    
          this.completedModalForm.openForm("Complete", `'${filename}' has been downloaded`, "https://cdn.lordicon.com/tsrgicte.json");
        });
    
        compRef.instance.errorEvent.subscribe(error => {
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation="Error: " + error;
        });
    
        colDiv.appendChild(compRef.location.nativeElement);
        container.appendChild(colDiv);
        this.downloadBoxRefs.push(compRef);
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  isSingleColumnCategory(category: string): boolean {
    return (this.groupedDownloadFiles[category]?.length || 0)===1;
  }
}
